import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
import { Leads, MarkLeads } from '../../medical-recored/mark-pat-expected-services/mark-pat-expected-services.service';

let markPatExpectedServiceUrl = CONFIG.baseUrls.markPatExpectedService;
let LeadAssignmentUrl = CONFIG.baseUrls.LeadAssignment;

export interface MarkPatExpectedServiceSearch {
  serial: number;
  leadTypeFlag?: number
  visitSerial: number;
  fromDate: Date;
  toDate: Date;
  patientCode: number;
  patCode: number
  docCode: number;
  serviceCode: number;
  leadType: number;
  type: number;
  offset: number;
  pageSize: number;
  mark_LeadsSerial?: number;
  selectDistinctFlag: number;
  forDiscountApproval?: number;
  operationStatus?: number;
  callsType?: number;
  operationPlace?: number;
  cCCallBeneficiary?: number;

}
export interface CallData {
  Serial?: number;
  phoneNumber?: number;
  regDate: Date;
  patCode?: number;
  docCode?: number;
  docNotesOnCall: string;
  fromDate: Date;
  toDate: Date;
  isModified: boolean;
  changeedNotes?: boolean;


}
export interface SearchCallData {
  patCode?: number;
  docCode?: number;
  fromDate: Date;
  toDate: Date;
  docNotesOnCall: string;
  callType: number;
}

export interface MarkPatExpectedServiceStepsDetail {
  serial: number;
  visitSerial: number;
  serviceId: number;
  steps: number;
  empId: number;
  status: boolean;
  excuted: number;
  expectedDate: Date;
  cCCallBeneficiaryCode: number;
  notes: string;
  timeFlag: number;
  dealStatus: number;
  mark_LeadsSerial: number;
  leadType?: number;
  repeatSerial?: number;
  todayCallFlag?: number;
}
@Injectable()
export class MarkPatExpectedServiceService {
  constructor(private httpGeneralService: HttpGeneralService) { }

  getMarkPatExpectedService(_MarkPatExpectedService: MarkPatExpectedServiceSearch) {
    return this.httpGeneralService.add<MarkPatExpectedServiceSearch>(_MarkPatExpectedService, `${markPatExpectedServiceUrl}/getMarkPatExpectedService`);
  }
  getMarkDocInCammingCall(_MarkPatExpectedService: SearchCallData) {

    return this.httpGeneralService.add<SearchCallData>(_MarkPatExpectedService, `${markPatExpectedServiceUrl}/getDocInCamCall`);
  }
  insertOrupdateMarkDocInCamCall(_MarkDocInCamCall: CallData[]) {

    return this.httpGeneralService.addCollection<CallData>(_MarkDocInCamCall, `${markPatExpectedServiceUrl}/AddMarkDocInCamCall`);
  }
  getMarkPatExpectedServiceDetail(markPatExpectedServiceSearchObj: MarkPatExpectedServiceSearch) {
    return this.httpGeneralService.add(markPatExpectedServiceSearchObj, `${markPatExpectedServiceUrl}/getMarkPatExpectedServiceDetail`)
  }

  getOperationLeads(markPatExpectedServiceSearchObj: MarkPatExpectedServiceSearch) {
    return this.httpGeneralService.add(markPatExpectedServiceSearchObj, `${markPatExpectedServiceUrl}/getOperationLeads`)
  }

  getLeadsByDoctors(markPatExpectedServiceSearchObj: MarkPatExpectedServiceSearch) {
    return this.httpGeneralService.add(markPatExpectedServiceSearchObj, `${markPatExpectedServiceUrl}/getLeadsByDoctors`)
  }
  getLeadAssignment(markPatExpectedServiceSearchObj: MarkPatExpectedServiceSearch) {
    return this.httpGeneralService.add(markPatExpectedServiceSearchObj, `${LeadAssignmentUrl}/getLeadAssignment`)
  }
  SaveLeadAssignment(markPatExpectedServiceSearchObj: any[]) {
    return this.httpGeneralService.post(markPatExpectedServiceSearchObj, `${LeadAssignmentUrl}/LeadAssignmentInsertOrUpdate`)
  }
  addMarkPatExpectedServiceStepsDetail(_markPatExpectedServiceStepList) {
    return this.httpGeneralService.add<MarkPatExpectedServiceStepsDetail>(_markPatExpectedServiceStepList, `${markPatExpectedServiceUrl}/AddMarkExpecServStepDetail`);
  }

  insertOrupdateMarkLeads(_AddMarkLeads: MarkLeads) {
    return this.httpGeneralService.add<MarkLeads>(_AddMarkLeads, `${markPatExpectedServiceUrl}/insertOrUpdateMark_leadsSave`);
  }

  approveRequest(aproveType) {
    return this.httpGeneralService.add(aproveType, `${markPatExpectedServiceUrl}/approveDiscountRequest`);
  }

  setOperationDoneAndFullPaidAll(markLeadsList) {
    return this.httpGeneralService.add<Leads>(markLeadsList, `${markPatExpectedServiceUrl}/setOperationDoneAndFullPaidAll`);
  }

  setِDiscountApprovalAll(markLeadsList) {
    return this.httpGeneralService.add<Leads>(markLeadsList, `${markPatExpectedServiceUrl}/setDiscountApprovalAll`);
  }

  deleteMarkPatExpectedService(id: number) {
    return this.httpGeneralService.delete<number>(id, markPatExpectedServiceUrl);
  }

  deleteMarkLead(serial: number) {
    return this.httpGeneralService.delete<number>(serial,
      `${markPatExpectedServiceUrl}/deleteMarkLead`);
  }


}
